import { render, staticRenderFns } from "./surveyPic.vue?vue&type=template&id=073bb98e&scoped=true"
import script from "./surveyPic.vue?vue&type=script&lang=js"
export * from "./surveyPic.vue?vue&type=script&lang=js"
import style0 from "./surveyPic.vue?vue&type=style&index=0&id=073bb98e&prod&lang=scss&scoped=true"
import style1 from "./surveyPic.vue?vue&type=style&index=1&id=073bb98e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073bb98e",
  null
  
)

export default component.exports